import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';
import usePageBackground from "../hooks/usePageBackground";
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { UserContexto } from './../app';
import { styled } from '@mui/material/styles';
import '../css/nav.css';
import '../css/global.css';
import '../css/about.css';
import FadeItem from "../components/fadeItem";
import { useFadeInOnScroll } from "../theme/global";
import * as endPoints from "../assets/js/endpoints";
import * as utils from "../assets/js/utils";
import Loader from '../components/loader';
import defaultImage from "../assets/images/espacios/recepción_3.jpeg";

function EmployeeSection({ employee, index }) {
  const imgRef = useFadeInOnScroll();
  const even = index % 2 === 0;
  const isFirst = index === 0;
  const bgColor = even ? '#FFFCE8' : '#C0DCBD';
 const padding = {
    xs: '3em 2em',
    md: '3em 8em',
  };
  const color = even ? '#66ab5ea3' : 'var(--color-light-beige)';

  const TextBox = (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'justify' }}>
      <FadeItem
        text={<b style={{ fontSize: '30px', fontWeight: 700, color: color }}>{employee.name}</b>}
        variant="h4"
        style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 400, color: '#66ab5ea3', mb: 4, fontSize: '24px' }}
      />
      {employee.biography?.map((text, idx) => (
        <FadeItem
          key={idx}
          text={text}
          style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 400, fontSize: '1.125em', color: '#7a7442', mb: 2 }}
        />
      ))}
    </Box>
  );

  const ImageBox = (
    <Box
      ref={imgRef}
      component="img"
      src={utils.image_path(employee.image) || defaultImage}
      alt={employee.name}
      className="fade-up"
      sx={{
        flex: 1,
        width: '100%',
        maxWidth: '500px',
        maxHeight: '550px',
        borderRadius: '8px',
        boxShadow: 3,
        objectFit: 'cover',
        height: 'auto',
      }}
    />
  );

  

  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        flexDirection: isFirst ? 'column' : { xs: 'column', md: 'row' },
        alignItems: 'center',
        padding,
        gap: 4,
        justifyContent: 'space-between',
        backgroundColor: bgColor,
      }}
    >
      {isFirst ? (
        <>
          {ImageBox}
          {TextBox}
        </>
      ) : even ? (
        <>
          {TextBox}
          {ImageBox}
        </>
      ) : (
        <>
          {ImageBox}
          {TextBox}
        </>
      )}
    </Container>
  );
}


export default function About() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    usePageBackground('about-background-color');

    const [employees, setEmployees] = useState([]);

    useEffect(() => {
      setLoading(true);
      const load = async () => {
        try {
          const data = await endPoints.getProviders();
         
          const list = (Array.isArray(data) ? data : data?.data) || [];     
          // list.sort((a, b) => Number(b.featured) - Number(a.featured));
          // setEmployees(list.map(u => ({
          //   ...u,
          //   biography: Array.isArray(u.biography)
          //     ? u.biography
          //     : typeof u.bio === 'string'
          //       ? u.bio.split('\n')
          //       : [],
          //   image: u.image,
          // })));
           const employees = list
        .filter(u => u.show_in_about !== false)
        .sort((a, b) => {
          const aOrder = Number(a.employee_order);
          const bOrder = Number(b.employee_order);
          const aHasOrder = Number.isFinite(aOrder) && aOrder > 0;
          const bHasOrder = Number.isFinite(bOrder) && bOrder > 0;

          if (aHasOrder && bHasOrder) return aOrder - bOrder;
          if (aHasOrder) return -1;
          if (bHasOrder) return 1;

          return `${a.name || ''} ${a.last_name || a.lastName || ''}`.localeCompare(
            `${b.name || ''} ${b.last_name || b.lastName || ''}`,
            'es',
            { sensitivity: 'base' }
          );
        })
        .map(u => ({
          ...u,
          biography: Array.isArray(u.biography)
            ? u.biography
            : typeof u.bio === 'string'
              ? u.bio.split('\n')
              : [],
          image: u.image,
        }));

      setEmployees(employees);
          setLoading(false);
           
       } catch (_err) {
          setLoading(false);
        }
      };
      load();
    }, []);

    const textInicio = [
        "CES está formado por personas. Personas que han elegido dedicar su vida a guiar a otros hacia su bienestar. Son profesionales que han decidido ser parte del cambio, asumiendo que el ser humano es un todo indivisible y apostando por el trabajo en equipo para alcanzar un objetivo común: la salud integral.",
      ];
    

      
   if (loading) return <Loader />;

    return (
        <>
        <Helmet>
          <title>Sobre Nosotras | CES</title>
          <meta name="description" content="Conoce al equipo de CES y nuestra misión de bienestar integral." />
        </Helmet>
        <Box
        maxWidth={false}
        sx={{
            textAlign: "center",    
            minHeight: "100vh",
            rowGap: 6,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: 'hidden',
            width: "100%", // El Box ocupa todo el ancho
            maxWidth: "100%",
          }}>
          <Container 
          maxWidth={false}
          sx={{
            mt: 2,
            backgroundColor: "#C0DCBD", // El color de fondo
            width: "100%", // El Container ocupa todo el ancho
            maxWidth: "100%", // Elimina el límite de ancho en el Container
            p: "3em 2em",
            m: 0, // Elimina cualquier margen
            }}>
          <FadeItem
            text="Quiénes somos"
            variant="h2"
            style={{ fontFamily: "Great Vibes, cursive", fontWeight: 400, color: "var(--color-light-beige)", mb: 2 }}
          />
    
          {textInicio.map((text, index) => (
            <FadeItem
              key={index}
              text={text}
              style={{ fontFamily: "Raleway, sans-serif", fontWeight: 400, fontSize: "1.3em", color: "var(--color-light-beige)", mb: 2, textAlign: "center",  }}
            />
          ))}
            </Container>   
    
          {employees.map((emp, idx) => (
            <EmployeeSection key={emp.id ?? idx} employee={emp} index={idx}/>
          ))}

        </Box>
        </>
      );
    };
    
